"use client";

import { ReactNode } from "react";
import { AlertCircle } from "lucide-react";

interface FormFieldProps {
  label: string;
  htmlFor?: string;
  error?: string;
  hint?: string;
  required?: boolean;
  children: ReactNode;
  className?: string;
}

export function FormField({
  label,
  htmlFor,
  error,
  hint,
  required = false,
  children,
  className = "",
}: FormFieldProps) {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      <label
        htmlFor={htmlFor}
        className="text-sm font-medium text-[var(--color-text-secondary)] flex items-center gap-1"
      >
        {label}
        {required && <span className="text-red-500">*</span>}
      </label>

      {children}

      {(error || hint) && (
        <div
          className={`flex items-start gap-1.5 text-sm ${error ? "text-red-600" : "text-[var(--color-text-muted)]"}`}
        >
          {error && <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />}
          <span>{error || hint}</span>
        </div>
      )}
    </div>
  );
}

export type { FormFieldProps };
